import type { ReactNode } from 'react'
import { ColumnFilter } from './ColumnFilter'
import type { TableControls } from './useAnalyticsTable'

/** Иконка сортировки в стиле AG Grid: две стрелки ▲/▼, активная — тёмная. */
function SortIcon({ active, dir }: { active: boolean; dir: 'asc' | 'desc' }) {
  return (
    <span className="inline-flex flex-col leading-none ml-1 text-[8px]">
      <span className={active && dir === 'asc' ? 'text-gray-700' : 'text-gray-300'}>▲</span>
      <span className={active && dir === 'desc' ? 'text-gray-700' : 'text-gray-300'}>▼</span>
    </span>
  )
}

/**
 * Заголовок таблицы «Аналитики» с клик-сортировкой и (опционально) фильтром-
 * выпадашкой. Управление берётся из useAnalyticsTable по ключу колонки.
 */
export function SortableTh({
  table,
  col,
  children,
  align = 'left',
  className = '',
}: {
  table: TableControls
  col: string
  children: ReactNode
  align?: 'left' | 'right'
  className?: string
}) {
  const sortable = table.isSortable(col)
  const filterable = table.isFilterable(col)
  const active = table.sortKey === col
  return (
    <th className={`py-2 font-medium ${className}`}>
      <div className={`flex items-center gap-1 ${align === 'right' ? 'justify-end' : ''}`}>
        {sortable ? (
          <button
            type="button"
            onClick={() => table.toggleSort(col)}
            className={`inline-flex items-center hover:text-gray-900 ${
              active ? 'text-gray-900' : 'text-gray-500'
            }`}
          >
            <span>{children}</span>
            <SortIcon active={active} dir={table.sortDir} />
          </button>
        ) : (
          <span>{children}</span>
        )}
        {filterable && (
          <ColumnFilter
            values={table.valuesFor(col)}
            selected={table.selectedFor(col)}
            onChange={(s) => table.setFilter(col, s)}
          />
        )}
      </div>
    </th>
  )
}
